module.exports = __webpack_public_path__ + "static/media/t2.b2b57dbc.png";